export const convertNumberToNumberStringWithComma = <T extends number | string | undefined | null>(value: T) => {
	return value ? String(value).replace('.', ',') : '';
};

export const convertNumberToNumberStringWithDot = <T extends number | string | undefined | null>(value: T) => {
	return value ? String(value).replace(',', '.') : '';
};
